<template>
  <div>
    <b-card no-body>
      <b-card-header>
        <span class="text-muted">
          <b>Soil Nutrients</b>
        </span>
      </b-card-header>
      <b-card-body class="mb-0">
        <b-table 
          :items="formResultData(results)" 
          :fields="columns" 
          class="mb-0" 
          bordered
          fixed
        />
        <div class="w-100">
          <div style="margin-left:5%;">
            <SoilNutrientsChart :results_total="results.total" />
          </div>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>
<script>
import { soil_nutrient_elements } from "@/shared/result-table-fields";
import SoilNutrientsChart from "@/components/modus/result/views/detailed/charts/SoilNutrientsChart.vue";
import ReportResultFormat from "@/components/shared/mixins/ReportResultFormat";
import ResultModel from "@/models/modus/ResultModel";

export default {
  name: "SoilNutrients",
  components: { SoilNutrientsChart },
  props: {
    results: {
      type: Object,
      default: () => new ResultModel()
    },
  },
  mixins: [ ReportResultFormat ],
  computed: {
    columns() {
      return [
        {key: "id", label: "Lab ID"},
        { key: "depth", label: "Depth" },
        ...soil_nutrient_elements.map(item => {
          return {
            key: item.element,
            label: `${item.element} ${item.unit || '-'}`
          }
        })
      ]
    },
  },
}
</script>